import { Cleaning } from '../../models/Cleaning/Cleaning';
import { Dispatch } from 'redux';
import { Location } from '../../models/Delivery/Delivery';

export const CLEANING_UPDATE_REQUEST = 'CLEANING_UPDATE_REQUEST';
export const CLEANING_UPDATE_DATETIME = 'CLEANING_UPDATE_DATETIME';
export const CLEANING_UPDATE_SEARCH_ADDRESSES = 'CLEANING_UPDATE_SEARCH_ADDRESSES';
export const CLEANING_UPDATE_ADDRESS = 'CLEANING_UPDATE_ADDRESS';

export const updateCleaningAction = (cleaning: Cleaning) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: CLEANING_UPDATE_REQUEST,
        cleaning
    });
};

export const updateCleaningDatetimeAction = (date: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: CLEANING_UPDATE_DATETIME,
        pickedDate: date
    });
};

export const updateCleaningSearchAddressesAction = (addresses: Location[]) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: CLEANING_UPDATE_SEARCH_ADDRESSES,
        searchResults: addresses
    });
};

export const updateCleaningAddressAction = (address: Location) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: CLEANING_UPDATE_ADDRESS,
        pickedAddress: address
    });
};



// WEBPACK FOOTER //
// ./src/actions/Cleaning/cleaning.ts